/* unplugin-vue-components disabled */import { render } from "./startDetect.vue?vue&type=template&id=329d64de"
import script from "./startDetect.vue?vue&type=script&lang=js"
export * from "./startDetect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__